<div class="agpr-rssFeedPicker">
    <div class="agpr-inputGroupRow">
        <div class="agpr-inputGroupRow-dropdown">
            <agpr-multi-select-dropdown
                class="agpr-rssFeedPicker-dropdown"
                [id]="id + '.rssFeedDropdown'"
                [(ngModel)]="selectedFeeds"
                (ngModelChange)="selectedFeedsChanged()"
                [optionsFetcher]="fetchFeed()"
                keyLookupField="id"
                labelLookupField="name"
                [placeholder]="'RSSFeeds.select'"
                ariaLabel="RSSFeedSelection"
                [displayChips]="false"
            ></agpr-multi-select-dropdown>
        </div>
        <div class="agpr-inputGroupRow-buttons">
            <agpr-button
                icon="fa-regular fa-duotone fa-gear"
                [id]="id + '.manageStyles'"
                [style]="buttonTypes.block"
                (click)="showRSSFeedManageDialog()"
                tooltip="RSSFeeds.manage"
                tooltipPosition="top"
            ></agpr-button>
        </div>
    </div>
    <ul id="rss_errors" *ngIf="isRssFeedMissing">
        <li>
            <agpr-form-message>
                {{ 'Briefings.deliveryOptions.rssFeed.required' | localize }}
            </agpr-form-message>
        </li>
    </ul>
    <ul *ngIf="value">
        <li *ngFor="let feed of value; index as i" class="agpr-rssFeedPicker-rssFeedCard agpr-contextMenu-parent">
            <div class="agpr-contextMenu top right">
                <agpr-button
                    icon="fa-regular fa-duotone fa-trash-can"
                    (click)="removeFromSelectedList(i)"
                    tooltip="RSSFeeds.remove"
                    [style]="buttonTypes.contextMenu"
                ></agpr-button>
            </div>
            <p class="agpr-rssFeedPicker-rssFeedCard-name"> {{ feed.name }} </p>
            <div class="agpr-rssFeedPicker-rssFeedCard-linkContainer">
                <span class="fa-regular fa-duotone fa-rss agpr-rssFeedPicker-rssFeedCard-linkContainer-icon"></span>
                <a class="agpr-rssFeedPicker-rssFeedCard-linkContainer-link" [href]="feed.url" target="_blank"> {{ feed.url }} </a>
            </div>
            <div class="agpr-rssFeedPicker-rssFeedCard-clearOnPublishContainer">
                <agpr-checkbox
                    [id]="id + '_' + feed.name + '_clearOnPublishCheckbox'"
                    label="RSSFeeds.clearOnPublish"
                    [binary]="true"
                    [(ngModel)]="feed.clearOnPublish"
                    (ngModelChange)="clearOnPublishChanged()"
                ></agpr-checkbox>
            </div>
        </li>
    </ul>
</div>
